import axios from "axios";
import { globalErrorHandler } from "../Api";
import {convertSHA} from "./ExtracurricularCoursesToken"

export const SEND_CERTIFICATE ="SEND_CERTIFICATE";
export const CER_LOADING = "CER_LOADING";
export const VERIF_SANITARIO = "VERIF_SANITARIO";
export const SEND_SANITARIO = "SEND_SANITARIO";



  const instance = axios.create({
    baseURL: process.env.REACT_APP_AYB_API_CER_URL,
    withCredentials: false,
    headers: {
      'Access-Control-Allow-Origin' : '*',
      'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS', 
      'content-type': 'application/json' 
      }
  });



  function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
  
    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;
  
    return [year, month, day].join('-');
  }
  export const sendCertificate= (badge,cetificate) => {
    var fecha = formatDate(Date());
    var params = JSON.stringify({
        "codigo_certificado":cetificate,
        "codigo_empleado": badge,
        "fecha_documento": fecha,
        "ciudad": " San Jose",
        "fecha_ini_incapacidad":fecha,
        "codemp_firma": badge
    });
    
    const config = {headers: { "content-type": "application/json",},}
    return async dispatch => {
      dispatch({
        type: CER_LOADING
      });
      //axios.defaults.headers.common["Authorization"] = "Bearer " +  localStorage.getItem("jwt_token");
      await instance.post(`/certificados?code=jqMWm9nF6EosjYak47tXUb/IA/XD81I2hU6wXs7nJcmcMceW3zGdWg==`,params, config).then((res => {
        dispatch({
          type: SEND_CERTIFICATE,
          data: res.data
        });
        console.log(res);
      })).catch(function (error) {
        console.log("Error", error);
      });
    }
  }

  export const VerifSanitario = (badge) =>{
    const config = {headers: { "content-type": "application/json",},}
    var Token = convertSHA()
    return async dispatch => {
      dispatch({
        type: CER_LOADING
      });
      //axios.defaults.headers.common["Authorization"] = "Bearer " +  localStorage.getItem("jwt_token");
      await axios.get(`https://sykesappscr.com/APICertificados/revision-sanitario?legajo=${badge}&token=${Token}`, config).then((res => {
        dispatch({
          type: VERIF_SANITARIO,
          data: res.data
        });
        console.log(res);
      })).catch(function (error) {
        console.log("Error", error);
      });
    }
  }

  export const SendSanitario = (badge, email) =>{
    const config = {headers: { "content-type": "application/json",},}
    var Token = convertSHA()
    return async dispatch => {
      dispatch({
        type: CER_LOADING
      });
      //axios.defaults.headers.common["Authorization"] = "Bearer " +  localStorage.getItem("jwt_token");
      await axios.get(`https://sykesappscr.com/APICertificados/certificado-sanitario?legajo=${badge}&email=${email}&token=${Token}`, config).then((res => {
        dispatch({
          type: SEND_SANITARIO,
          data: res.data
        });
        console.log(res);
      })).catch(function (error) {
        console.log("Error", error);
      });
    }
  }

  // export const sendCertificate2 = (badge,cetificate) => {
  //   const config = {
  //     headers: {
  //       "content-type": "application/json",
  //     },
  //   };
  //   var fecha = formatDate(Date());
  //   var params = JSON.stringify({
  //       "codigo_certificado":cetificate,
  //       "codigo_empleado": '2000'+badge,
  //       "fecha_documento": fecha,
  //       "ciudad": " San Jose",
  //       "fecha_ini_incapacidad":fecha,
  //       "codemp_firma": '2000'+badge
  //   });
  //   return async (dispatch) => {
  //     dispatch({
  //       type: CER_LOADING,
  //     });
  //     await axios
  //       .post(
  //         //`/api/chatbot/cafeteriaDetail`,
  //         `https://sykesapifunc.azurewebsites.net/api/certificados?code=jqMWm9nF6EosjYak47tXUb/IA/XD81I2hU6wXs7nJcmcMceW3zGdWg==`,
  //         params,
  //         config
  //       )
  //       .then((res) => {
  //         dispatch({
  //           type: SEND_CERTIFICATE,
  //           data: res.data,
  //         });
  //       })
  //       .catch(globalErrorHandler);
  //   };
  // };

  
